import { ActionsCell } from "../../../../Component/Common/Components/DataTable/ActionsCell";
import { DefaultCell } from "../../../../Component/Common/Components/DataTable/DefaultCell";
import { Note } from "../../../../Component/Model/Dto/Note";
import { DataTableHtmlFormatter, TableDateHelper } from "../../../../Component/Model/helpers";
import { ActionType, TableColumn } from "../../../../Component/Model/Table/Table";

interface FeedbackRow {
    Id:                     string;
    User:                   string;
    Date?:                  string;
    Feedback:               string;
    Actions?:               ActionType[];
}

interface FeedbackTable {
    columns: Array<TableColumn>;
    rows: Array<FeedbackRow>;
}

export function FeedbackTableMapper(dataObject: Note.FeedbackSearchDtoIn[], handleDelete: (id: string) => void ): FeedbackTable {
    const columns = [
        { Header: 'User', accessor: 'User', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Date', accessor: 'Date', Cell: ({ value }: any) => <DefaultCell value={value}/> },
        { Header: 'Feedback', accessor: 'Feedback', Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true}/> },
        { Header: 'Actions', accessor: 'Actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true},
    ];
    if (dataObject !== undefined && dataObject.length > 0){

        const rows = dataObject.map((item: Note.FeedbackSearchDtoIn) => ({
            Id: item.Id,
            User: item.Username,
            Date: TableDateHelper(item.CreatedDate),
            Feedback: DataTableHtmlFormatter(item.Feedback, ' '),
            Actions: [
                { label: 'Delete', action: handleDelete, key: item.Id, icon: { color: 'error', name: 'delete' } }]
        }));

        return { columns: columns, rows: rows };
        
    }else {
        return { columns: columns, rows: [] };
    }
}